import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import AdminLayout from '../components/AdminLayout';
import { apiFetch } from '../api';
import {
  PageHeader, Loading, ErrorBanner, Empty, Badge, StatCard, ui,
} from '../components/adminUi';

// FAZA 7 — moliyaviy hisobot, kredit DAFTARIGA asoslangan.
//
// MUHIM tushuncha (sahifada ham izohlanadi): kredit OLDINDAN to'lanadi.
// To'ldirish — bu hali daromad EMAS, u ustaning hisobidagi pul (majburiyat);
// daromad kredit SARFLANGANDA tan olinadi — kelishuv ulushi yoki Prime obunasi.
export default function ReportsPage() {
  const { auth } = useAuth();

  const [period, setPeriod] = useState('daily');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setFetchError('');
    try {
      const res = await apiFetch(`/api/admin/reports/money?period=${period}`, auth.token);
      if (!res.ok) throw new Error();
      setData(await res.json());
    } catch {
      setData(null);
      setFetchError('Hisobotni yuklashda xatolik. Sahifani yangilang.');
    } finally {
      setLoading(false);
    }
  }, [auth.token, period]);

  useEffect(() => { load(); }, [load]);

  const buckets = data?.buckets ?? [];
  const t = data?.totals ?? null;
  const maxTotal = Math.max(1, ...buckets.map((b) => b.total || 0));

  return (
    <AdminLayout>
      <PageHeader title="Moliyaviy hisobot" subtitle="TezHal daromadi, kredit aylanmasi va majburiyatlar">
        <div style={s.periodRow}>
          {PERIODS.map((p) => (
            <button
              key={p.key}
              style={{ ...s.periodBtn, ...(period === p.key ? s.periodBtnActive : {}) }}
              onClick={() => setPeriod(p.key)}
            >
              {p.label}
            </button>
          ))}
        </div>
        <button style={ui.pagerBtn} onClick={load}>↻ Yangilash</button>
      </PageHeader>

      <ErrorBanner>{fetchError}</ErrorBanner>

      {loading ? (
        <Loading />
      ) : !t ? (
        <Empty icon="📊" title="Ma'lumot yo'q" hint="Hisobot shakllanishi uchun bitim yoki obuna kerak." />
      ) : (
        <>
          <h3 style={s.section}>Daromad</h3>
          <div style={ui.statGrid}>
            <StatCard label="TezHal daromadi" value={money(t.revenue)} accent="var(--success)" />
            <StatCard label={`Bitim ulushlari (${t.dealFees.n} ta)`} value={money(t.dealFees.sum)} accent="#2563eb" />
            <StatCard label={`Prime obunalari (${t.prime.n} ta)`} value={money(t.prime.sum)} accent="#b45309" />
          </div>

          <h3 style={s.section}>Kredit aylanmasi</h3>
          <p style={s.hint}>
            Kredit <b>oldindan</b> to'lanadi: to'ldirish hali daromad emas — u ustaning hisobidagi
            pul (<b>majburiyat</b>). Daromad kredit sarflanganda tan olinadi.
          </p>
          <div style={ui.statGrid}>
            <StatCard label={`To'ldirishlar (${t.topups.n} ta)`} value={money(t.topups.sum)} accent="#2563eb" />
            <StatCard label="Ustalar qo'lidagi kredit" value={money(t.liability)} accent="#b45309" />
            <StatCard label="Berilgan bonuslar" value={money(t.bonuses)} accent="var(--text-muted)" />
          </div>

          <h3 style={s.section}>E'tibor talab qiladi</h3>
          <div style={ui.statGrid}>
            <StatCard
              label={`Undirilmagan ulush (${t.pendingFees.n} ta)`}
              value={money(t.pendingFees.sum)}
              accent={t.pendingFees.sum > 0 ? 'var(--danger)' : 'var(--text-muted)'}
            />
            <StatCard
              label={`Manfiy balanslar`}
              value={money(t.debt)}
              accent={t.debt > 0 ? 'var(--danger)' : 'var(--text-muted)'}
            />
            <StatCard
              label={`Prime tufayli olinmadi (${t.waivedFees.n} ta)`}
              value={money(t.waivedFees.sum)}
              accent="var(--text-muted)"
            />
          </div>

          <h3 style={s.section}>Platforma aylanmasi</h3>
          <p style={s.hint}>
            Yakunlangan bitimlarning umumiy summasi — bu TezHal daromadi <b>emas</b>, mijoz
            ustaga to'laydigan pul. Platforma hajmini ko'rsatadi.
          </p>
          <div style={ui.statGrid}>
            <StatCard label={`Bitimlar hajmi (${t.gmv.n} ta)`} value={money(t.gmv.sum)} accent="#2563eb" />
          </div>

          {buckets.length === 0 ? (
            <Empty icon="📊" title="Bu davr uchun daromad yo'q" hint="Bitim yoki Prime obunasi paydo bo'lgach shakllanadi." />
          ) : (
            <>
              <div style={s.chartCard}>
                <div style={s.chartTitle}>Daromad dinamikasi</div>
                <div style={s.chart}>
                  {[...buckets].reverse().map((b, i) => (
                    <div key={i} style={s.barCol} title={`${b.period}: ${money(b.total)} so'm`}>
                      <div style={{ ...s.bar, height: `${Math.max(4, Math.round((b.total / maxTotal) * 140))}px` }} />
                      <span style={s.barLabel}>{shortLabel(b.period)}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div style={ui.tableWrap}>
                <table style={ui.table}>
                  <thead>
                    <tr>
                      <th style={ui.th}>Davr</th>
                      <th style={{ ...ui.th, textAlign: 'right' }}>Bitim ulushlari</th>
                      <th style={{ ...ui.th, textAlign: 'right' }}>Prime</th>
                      <th style={{ ...ui.th, textAlign: 'right' }}>Jami</th>
                      <th style={{ ...ui.th, textAlign: 'right' }}>Bitimlar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {buckets.map((b, i) => (
                      <tr key={i} style={ui.tr}>
                        <td style={{ ...ui.td, fontWeight: '600', color: 'var(--text)' }}>{b.period}</td>
                        <td style={{ ...ui.td, textAlign: 'right' }}>{money(b.dealFees)}</td>
                        <td style={{ ...ui.td, textAlign: 'right' }}>{money(b.prime)}</td>
                        <td style={{ ...ui.td, textAlign: 'right', fontWeight: '700', color: 'var(--text)' }}>
                          {money(b.total)}
                        </td>
                        <td style={{ ...ui.td, textAlign: 'right' }}>{b.deals}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}

          {data.topProviders.length > 0 && (
            <>
              <h3 style={{ ...s.section, marginTop: '28px' }}>Eng ko'p ulush to'lagan ustalar</h3>
              <div style={ui.tableWrap}>
                <table style={ui.table}>
                  <thead>
                    <tr>
                      <th style={ui.th}>Usta</th>
                      <th style={ui.th}>Telefon</th>
                      <th style={{ ...ui.th, width: '130px' }}>Prime</th>
                      <th style={{ ...ui.th, width: '120px', textAlign: 'right' }}>Bitimlar</th>
                      <th style={{ ...ui.th, width: '160px', textAlign: 'right' }}>To'langan</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.topProviders.map((p) => (
                      <tr key={p.id} style={ui.tr}>
                        <td style={{ ...ui.td, fontWeight: '600', color: 'var(--text)' }}>
                          {[p.firstName, p.lastName].filter(Boolean).join(' ') || `#${p.id}`}
                        </td>
                        <td style={ui.td}>{p.phone || '—'}</td>
                        <td style={ui.td}>
                          {p.primeActive
                            ? <Badge tone="amber">⭐ Faol</Badge>
                            : <span style={{ color: 'var(--text-faint)' }}>—</span>}
                        </td>
                        <td style={{ ...ui.td, textAlign: 'right' }}>{p.deals}</td>
                        <td style={{ ...ui.td, textAlign: 'right', fontWeight: '700', color: 'var(--text)' }}>
                          {money(p.paid)} so'm
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </>
      )}
    </AdminLayout>
  );
}

const PERIODS = [
  { key: 'daily', label: 'Kunlik' },
  { key: 'weekly', label: 'Haftalik' },
  { key: 'monthly', label: 'Oylik' },
];

// Bo'sh joyli format: 1 000 000
function money(v) {
  const n = Number(v);
  if (!Number.isFinite(n) || n === 0) return '0';
  const sign = n < 0 ? '−' : '';
  return sign + Math.round(Math.abs(n)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

function shortLabel(l) {
  const str = String(l || '');
  return str.length > 6 ? str.slice(5) : str;
}

const s = {
  section: { margin: '22px 0 12px', fontSize: '16px', fontWeight: '700', color: 'var(--text)' },
  hint: { margin: '-6px 0 14px', fontSize: '13px', color: 'var(--text-muted)', maxWidth: '760px' },
  periodRow: {
    display: 'flex', gap: '6px', background: 'var(--surface)', padding: '4px',
    borderRadius: '10px', border: '1px solid #e5e7eb',
  },
  periodBtn: {
    padding: '8px 18px', background: 'transparent', color: 'var(--text-muted)',
    border: 'none', borderRadius: '7px', fontSize: '14px', cursor: 'pointer', fontWeight: '500',
  },
  periodBtnActive: { background: 'var(--brand)', color: 'var(--on-accent)' },
  chartCard: {
    background: 'var(--surface)', borderRadius: '12px', padding: '20px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.08)', margin: '20px 0',
  },
  chartTitle: { fontSize: '14px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '16px' },
  chart: {
    display: 'flex', alignItems: 'flex-end', gap: '10px', height: '170px',
    overflowX: 'auto', paddingBottom: '4px',
  },
  barCol: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px', minWidth: '38px' },
  bar: { width: '28px', background: 'linear-gradient(180deg, #16a34a, #15803d)', borderRadius: '6px 6px 0 0' },
  barLabel: { fontSize: '11px', color: 'var(--text-faint)', whiteSpace: 'nowrap' },
};
